export const ColorPicker = {
  "Current": "Current",
  "New": "New"
}